<div class="node" [style.paddingLeft.px]="node.hierarchyLevel * 0">
  <div class="node-content">
    <div class="selector-wrapper">
      <!-- <div class="horizontal-line" *ngIf="node.parentId"></div> -->
      <button class="arrow-button" nbButton *ngIf="node.children?.length" (click)="toggle()" size="tiny">
        {{ node.expanded ? '▾' : '▸' }}
      </button>
      <button nbButton (click)="toggle()" size="tiny" class="node-button">
        {{ node.name }}
      </button>
      <span *ngIf="node.confidence">({{ node.confidence | number: '1.0-2' }}%)</span>
      <div class="checkbox-container">
        <nb-checkbox 
        status="basic" 
        [checked]="node.selected"
        [indeterminate]="node.indeterminate"
        (checkedChange)="toggleSelection($event)"
        >
      </nb-checkbox>
      <span class="node-name">
        <ng-container *ngIf="node.children?.length">
          Select All
        </ng-container>
      </span>
      </div>
    </div>
    
    <div *ngIf="node.expanded" class="children">
      <div class="vertical-line"></div> <!-- Main vertical connector -->
      <div class="child-wrapper" *ngFor="let child of node.children">
        <div class="horizontal-line"></div> <!-- Horizontal line for this child -->  
        <ubs-catalog-node class="child-node"
          [node]="child"
          (select)="select.emit($event)">
        </ubs-catalog-node>
      </div>
      
    </div>
  </div>
</div>
  
